<template>
    <div class="uk-padding uk-background-muted" >
        <h1 class="uk-text-center">
            <span class="half-a-border-on-top">We Are NCU</span>
        </h1>
        <br>
        <div class="uk-container ">
            <div class="uk-width-1-1@m  ">
                <!--<h4 class="uk-heading-divider "><span class="uk-text-bold">Current Students Stories</span></h4>-->
                <div uk-slider="center: false">

                    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">

                        <ul class="uk-slider-items uk-child-width-1-3@s ">

                            <li >
                                <video  src="../../assets/StudentAdvice_JohnMarc.mp4" controls loop  playsinline uk-video="autoplay: none"></video>
                            </li>
                            <li>
                                <video src="../../assets/StudentAdvice_Britney.mp4" controls loop  playsinline uk-video="autoplay: none"></video>
                            </li>
                            <li>
                                <video src="../../assets/StudentAdvice_Roscene.mp4" controls loop muted playsinline uk-video="autoplay: none"></video>
                            </li>

                            <li>
                                <iframe width="370" height="500" src="https://www.youtube.com/embed/bhEATmjX02w" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </li>

                        </ul>

                        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

                    </div>

                    <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>

                </div>
            </div>
            <!--<div class="uk-width-1-2@m ">
                <h4 class="uk-heading-divider"><span class="uk-text-bold">Past Students Stories</span></h4>
                <div uk-slider="center: false">

                    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">

                        <ul class="uk-slider-items uk-child-width-1-3@s uk-grid" style="padding-left: 5px; padding-right: 5px;  margin-bottom: 15px">
                            <li>
                                <iframe width="370" height="500" src="https://www.youtube.com/embed/YIoEGtrPqYI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </li>
                            <li>
                                <iframe width="370" height="500" src="https://www.youtube.com/embed/hurfsMdaXVU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </li>
                            <li>
                                <iframe width="370" height="500" src="https://www.youtube.com/embed/bhEATmjX02w" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </li>

                        </ul>

                        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

                    </div>

                    <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>

                </div>
            </div>-->
        </div>

    </div>
</template>

<script>
    export default {
        name: "ourStories"
    }
</script>

<style scoped>
    .half-a-border-on-top {
        border-top: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: #f5f5f5;
        position: absolute;
        right:0;
        top:-2px;
    }
    h4 span{
        font-variant: all-small-caps;
        font-size: x-large;
        color: #033860;
        font-weight: bolder;
    }
</style>